import React from 'react'

import { NextPage } from 'next'

import PrivateRouteLayout from '@/components/Layouts/PrivateRoute'
import { WorkQueues } from '@/features/WorkQueues'

const WorkViewsPage: NextPage = () => {
  return (
    <PrivateRouteLayout hideNavigation>
      <WorkQueues />
    </PrivateRouteLayout>
  )
}

export default WorkViewsPage
